/**
 * 報價單品項「保存期限」的單一取值來源（需求 R121 R2）。
 *
 * 為什麼需要這支：PM 2026-08-19 回報「QT-20260818-004 的
 * A003511 自然足跡-黑糖薑母茶 保存期限是 18 個月，但報價單匯出沒有顯示」。
 * 追下去發現不是用字問題（R1 已把「保質期」改成「保存期限」），而是**取值鏈路**：
 *
 *   1) 報價單品項快照（Quote.items）原本**沒有** shelfLife 欄位，匯出時只讀
 *      `item.product.shelfLife` —— 那是 GET /api/quotes/:id 才有的 populate 結果。
 *   2) 從「編輯報價單」頁匯出時走的是 QuoteEditPage.buildExportQuoteObj()，
 *      它自己重組一份 quote 物件，`product.shelfLife` 讀的是 `it.shelfLife`，
 *      而 items state 從頭到尾沒有人寫過這個欄位 → **永遠是空字串**。
 *      這正是 PM 匯出時整欄空白的直接原因（詳情頁匯出因為有 populate 才看得到）。
 *
 * 修法：品項快照補存 shelfLife（見 src/server/models/Quote.js），並由本函式統一
 * 「快照 → populate 的產品 → 抽屜用的實時產品資料」三層 fallback，讓 PDF／Excel
 * 兩條匯出路徑、詳情頁與編輯頁四個進入點都拿到同一個值。既有報價單沒有快照也不必
 * 資料遷移——第二、三層 fallback 就會補上。
 */

/**
 * @param {object} item 報價單品項（可能來自 DB 快照、populate 結果或編輯頁 state）
 * @returns {string} 保存期限字串；沒有值時回空字串（呼叫端據此決定不輸出那一行）
 */
export function getItemShelfLife(item) {
  if (!item) return '';
  // item.product 可能是 ObjectId 字串（編輯頁新加入的品項）或 populate 後的物件，
  // 只有物件才有 shelfLife 可讀。
  const populated = item.product && typeof item.product === 'object' ? item.product.shelfLife : '';
  const candidates = [item.shelfLife, populated, item._productData ? item._productData.shelfLife : ''];
  for (const value of candidates) {
    if (value == null) continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return '';
}

export default getItemShelfLife;
